import clsx from 'clsx'
import { MiteneIconBase, MiteneIconProps } from 'components/atoms/icons/MiteneIconBase'
import { FC } from 'react'

interface Props extends MiteneIconProps {
  size?: MiteneIconProps['size']
}

export const LightBulbIcon: FC<Props> = ({ size = 24, className, ...props }) => {
  return (
    <MiteneIconBase
      viewBox='0 0 24 24'
      size={size}
      className={clsx(className)}
      {...props}
    >
      <path
        fill='#FFBA18'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.6587 6.3498L18.5587 8.5498L17.4587 6.3498L15.1587 5.3498L17.4587 4.3498L18.5587 2.0498L19.6587 4.2498L21.9587 5.2498L19.6587 6.3498ZM11.4587 18.5498C11.4587 18.5498 11.1587 18.5498 8.75867 18.5498H6.05867C5.75867 18.3498 5.75867 17.6498 5.65867 17.1498C5.65867 16.8498 5.45867 16.6498 5.25867 16.4498C-2.74133 10.6498 5.75867 -0.250195 13.5587 5.9498C16.5587 8.3498 16.4587 13.4498 13.0587 15.7498C12.5587 16.1498 12.2587 16.3498 11.9587 16.6498C11.5587 16.9498 11.8587 18.2498 11.4587 18.5498ZM5.95867 19.8498H11.3587C11.8587 22.6498 5.55867 22.6498 5.95867 19.8498Z'
      />
    </MiteneIconBase>
  )
}
